import { render, staticRenderFns } from "./LoginCidadao.vue?vue&type=template&id=0adbb4b3&"
import script from "./LoginCidadao.vue?vue&type=script&lang=js&"
export * from "./LoginCidadao.vue?vue&type=script&lang=js&"
import style0 from "./LoginCidadao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports